var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheck = function SvgCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#check_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2FCE82",
    d: "M10 .508c-5.52 0-10 4.48-10 10s4.48 10 10 10 10-4.48 10-10a10.03 10.03 0 0 0-10-10"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16.09 6.768a.87.87 0 0 0-1.24-.01l-.01.01-6.56 6.57-2.76-2.77a.9.9 0 0 0-1.27-.01.9.9 0 0 0-.02 1.27l.04.04 3.38 3.38c.34.35.9.35 1.24.01l.01-.01 7.18-7.18c.36-.33.38-.89.05-1.24-.01-.03-.02-.04-.04-.06"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "check_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 .508h20v20H0z"
  })))));
};
export default SvgCheck;